import React from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { useTranslation } from 'react-i18next';

const SupportPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isNative = Capacitor.isNativePlatform();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-10">
      <div className="max-w-4xl mx-auto">
        {isNative && (
          <button
            onClick={handleBack}
            className="mb-6 flex items-center gap-2 text-sm font-semibold text-gray-700 active:scale-95 transition"
          >
            <span className="text-xl leading-none">‹</span>
            {t('common.back')}
          </button>
        )}

        <h1 className="text-3xl font-bold mb-2">{t('support.title')}</h1>
        <p className="text-sm text-gray-500 mb-8">{t('support.last_update')}</p>

        <Section title={t('support.s1_title')}>
          <p>{t('support.s1_p1')}</p>
          <p className="mt-2">{t('support.s1_p2')}</p>
        </Section>

        <Section title={t('support.s2_title')}>
          <p>{t('support.s2_p1')}</p>
          <p className="mt-2">{t('support.s2_p2')}</p>
        </Section>

        <Section title={t('support.s3_title')}>
          <p>{t('support.s3_p1')}</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>{t('support.s3_li1')}</li>
            <li>{t('support.s3_li2')}</li>
            <li>{t('support.s3_li3')}</li>
            <li>{t('support.s3_li4')}</li>
          </ul>
        </Section>

        <Section title={t('support.s4_title')}>
          <p>{t('support.s4_p1')}</p>
        </Section>

        <Section title={t('support.s5_title')}>
          <p><strong>{t('support.s5_app')}:</strong> DragonFit</p>
          <p><strong>{t('support.s5_responsible')}:</strong> Mikel Nieto Irureta</p>
          <p><strong>{t('support.s5_country')}:</strong> España</p>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-semibold mb-3">{title}</h2>
    <div className="space-y-2 text-sm leading-relaxed">{children}</div>
  </section>
);

export default SupportPage;
